import React, { useState } from "react";
import "../styles/contact.css";
import Navbar from "../components/layout/Navbar";
import SeoHead from "../components/SeoHead";

const LOCATIONS = [
  {
    name: "Medicover Hospitals",
    area: "Hitech City, Hyderabad",
    badge: "Primary",
    timings: "10:00 AM – 4:00 PM",
    appointmentsLabel: "Appointments",
    appointments: "+91 4068 334455",
    directLabel: "Direct Contact",
    direct: "+91 9573152875",
    address: "Beside Cyber Towers, Lane of IBIS Hotels, Madhapur, Hyderabad – 500081",
  },
  {
    name: "Agastya Hospitals",
    area: "LB Nagar, Hyderabad",
    badge: "Evening",
    timings: "5:00 PM onwards",
    appointmentsLabel: "Appointments",
    appointments: "+91 94591 08108",
    bookingLabel: "Booking",
    booking: "By prior appointment only",
    address: "Nagarjuna Sagar Road, L.B. Nagar, Hyderabad – 500079",
  },
];

const CONCERNS = [
  "Hand Injury / Fracture",
  "Wrist Pain / Arthroscopy",
  "Nerve Compression / Carpal Tunnel",
  "Brachial Plexus Injury",
  "Tendon / Ligament Repair",
  "Congenital Deformity",
  "Second Opinion",
  "Other",
];

const PREFERRED_LOCATIONS = [
  "Medicover Hospitals, Hitech City",
  "Agastya Hospitals, LB Nagar",
  "Either — whichever is sooner",
];

// Map icon reused across cards
const MapPin = ({ size = 20, color = "#C9A84C" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
      fill={color}
    />
    <circle cx="12" cy="9" r="2.5" fill="#fff" />
  </svg>
);

const ClockIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const PhoneIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const CalendarIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

export default function ContactPage() {
  const [selected, setSelected] = useState("");

  return (
    <div className="cp-page">

      <SeoHead
        title="Contact & Appointments — Hand & Wrist Clinics, Hyderabad"
        description="Book an appointment with Dr. R. Suneel at Medicover Hospitals Hitech City or Agastya Hospitals LB Nagar. Call +91 9573152875."
        keywords="contact Dr R Suneel, hand surgeon Hyderabad contact, book hand surgery appointment Hyderabad, wrist surgeon appointment Hyderabad, hand and wrist clinic Hyderabad, hand surgery consultation Hyderabad, peripheral nerve specialist Hyderabad, brachial plexus surgeon Hyderabad, Medicover Hitech City hand surgeon, hand surgery clinic Madhapur, orthopedic hand specialist Hyderabad, Dr R Suneel appointment"
        url="https://www.handandwristclinics.com/contact"
      />

      {/* HERO + BREADCRUMB */}
      <header className="cp-hero">
        <div className="cp-hero-inner">
          <nav className="cp-breadcrumb" aria-label="Breadcrumb">
            <a href="/">Home</a>
            <span className="cp-bc-sep">/</span>
            <span className="cp-bc-current">Contact</span>
          </nav>
          <div className="cp-eyebrow">
            <span></span> Get in Touch
          </div>
          <h1 className="cp-title">
            Book an <em>Appointment</em>
          </h1>
          <div className="cp-divider" />
          <p className="cp-hero-sub">
            Reach out for consultations, appointments, or emergency hand care.
            Our team is here to help you at every step.
          </p>
        </div>
      </header>

      {/* MAIN — Locations (left) + Form (right) */}
      <section className="cp-section cp-main">
        <div className="cp-container">
          <div className="cp-main-grid">

            {/* LEFT: Locations */}
            <div className="cp-left">
              <div className="cp-section-tag">Our Locations</div>
              <h2 className="cp-section-title">
                Visit us at <em>two convenient clinics</em>
              </h2>
              <div className="cp-divider" />

              <div className="cp-loc-stack">
                {LOCATIONS.map((l, i) => (
                  <article className="cp-loc-card" key={i}>
                    <div className="cp-loc-header">
                      <div className="cp-loc-pin">
                        <MapPin size={22} />
                      </div>
                      <div className="cp-loc-title-wrap">
                        <h3 className="cp-loc-name">{l.name}</h3>
                        <p className="cp-loc-area">{l.area}</p>
                      </div>
                      <span className={`cp-loc-badge ${l.badge === "Primary" ? "cp-badge-primary" : "cp-badge-evening"}`}>
                        {l.badge}
                      </span>
                    </div>

                    <div className="cp-loc-rows">
                      <div className="cp-loc-row">
                        <ClockIcon />
                        <div className="cp-loc-row-text">
                          <span className="cp-loc-label">Timings</span>
                          <span className="cp-loc-value">{l.timings}</span>
                        </div>
                      </div>
                      {l.appointments && (
                        <div className="cp-loc-row">
                          <PhoneIcon />
                          <div className="cp-loc-row-text">
                            <span className="cp-loc-label">{l.appointmentsLabel}</span>
                            <a className="cp-loc-link" href={`tel:${l.appointments.replace(/\s/g, "")}`}>
                              {l.appointments}
                            </a>
                          </div>
                        </div>
                      )}
                      {l.direct && (
                        <div className="cp-loc-row">
                          <PhoneIcon />
                          <div className="cp-loc-row-text">
                            <span className="cp-loc-label">{l.directLabel}</span>
                            <a className="cp-loc-link" href={`tel:${l.direct.replace(/\s/g, "")}`}>
                              {l.direct}
                            </a>
                          </div>
                        </div>
                      )}
                      {l.booking && (
                        <div className="cp-loc-row">
                          <CalendarIcon />
                          <div className="cp-loc-row-text">
                            <span className="cp-loc-label">{l.bookingLabel}</span>
                            <span className="cp-loc-value cp-loc-muted">{l.booking}</span>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="cp-loc-address">
                      <MapPin size={14} color="#5E5CB8" />
                      <span>{l.address}</span>
                    </div>
                  </article>
                ))}
              </div>

              {/* Quick-contact strip */}
              <div className="cp-contact-strip">
                <div className="cp-strip-item">
                  <div className="cp-strip-icon cp-strip-wa">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.84 12.84 0 0 0-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>
                    </svg>
                  </div>
                  <div>
                    <div className="cp-strip-label">Second Opinion (WhatsApp only)</div>
                    <a className="cp-strip-value" href="https://wa.me/917842170179">+91 78421 70179</a>
                  </div>
                </div>
                <div className="cp-strip-divider" />
                <div className="cp-strip-item">
                  <div className="cp-strip-icon cp-strip-email">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                      <polyline points="22,6 12,13 2,6"/>
                    </svg>
                  </div>
                  <div>
                    <div className="cp-strip-label">Email Us</div>
                    <a className="cp-strip-value" href="mailto:handandwristclinics@gmail.com">handandwristclinics@gmail.com</a>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT: WhatsApp Booking Widget */}
            <div className="cp-right">
              <div className="cp-wa-wrap">
                <div className="cp-wa-icon-wrap">
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="white">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.84 12.84 0 0 0-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>
                  </svg>
                </div>
                <h3 className="cp-wa-title">Book via WhatsApp</h3>
                <p className="cp-wa-sub">Select your concern and tap the button — it opens a pre-filled WhatsApp chat directly with the doctor's team.</p>

                <div className="cp-wa-chips">
                  {CONCERNS.map((c) => (
                    <button
                      key={c}
                      className={`cp-wa-chip${selected === c ? " cp-wa-chip-active" : ""}`}
                      onClick={() => setSelected(c)}
                      type="button"
                    >
                      {c}
                    </button>
                  ))}
                </div>

                <a
                  className="cp-wa-btn"
                  href={`https://wa.me/917842170179?text=${encodeURIComponent(`Hi, I'd like to book an appointment for: ${selected || "[please select a concern above]"}`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.84 12.84 0 0 0-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>
                  </svg>
                  Open WhatsApp Chat
                </a>

                <p className="cp-wa-note">+91 78421 70179 · Typically replies within a few hours</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* EMERGENCY BANNER
      <section className="cp-emergency">
        <div className="cp-container cp-emergency-inner">
          <div className="cp-emergency-left">
            <div className="cp-emergency-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
            </div>
            <div>
              <h3 className="cp-emergency-title">Emergency Hand Injury?</h3>
              <p className="cp-emergency-text">
                Available 24/7 for traumatic hand injuries, crush injuries, and
                amputations requiring immediate care.
              </p>
            </div>
          </div>
          <a className="cp-emergency-cta" href="tel:+919393408108">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            Call Now: +91 93934 08108
          </a>
        </div>
      </section> */}
      
    </div>
  );
}